import Preview from './Preview.svg';

export default function EnrichmentLogsPlaceholder({ className }) {
  return (
    <div className={classnames('flex flex-col items-center', className)}>
      <Preview className="mb-6" />

      <h1 className="mb-2 font-semibold text-gray-700 text-md">
        There have been no enrichments, yet.
      </h1>

      <p className="text-gray-600">
        Once Salesforce accounts, contacts, or leads have been enriched,
        <br /> details of those enrichments will appear here as enrichment logs.
      </p>
    </div>
  );
}
